import React, {Fragment, ReactElement} from 'react';
type StoreScanProps = {
  title1: string | null;
  title2: string | null;
};
const StoreScanMessage = ({title1, title2}: StoreScanProps): ReactElement => {
  return (
    <div className="font-light font-roboto leading-9 mb-4 text-big text-center tracking-normal">
      <div className=" grid place-items-center mt-4 ">
        <span className="">{title1}</span>
      </div>
      <div className="  grid place-items-center mt-2 mx-auto">
        <span className="font-bold font-roboto">{title2}</span>
      </div>
    </div>
  );
};
export default StoreScanMessage;
